import styled from 'styled-components';

const NewButton = styled.button.attrs((props) => ({
  type: props.type || 'button',
  disabled: props.disabled
}))`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  column-gap: 4px;
  width: ${(props) => (props.block ? '100%' : 'auto')};

  border-radius: 8px;
  border: 1px solid var(--border-muted);

  padding: 7px;
  // This doesn't match Figma because Figma measures the padding to the outer edge of the border,
  // and CSS to the inner. 8px - 1px (border width)

  font-family: var(--font-family-title);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 20px;
  white-space: nowrap;

  background: transparent;
  transition: background 0.1s, color 0.1s;
  cursor: pointer;

  ${({ secondary, tertiary, primary, active, disabled }) => {
    if (disabled) {
      let baseStyles = `
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
      `;

      if (primary) {
        baseStyles += `
          color: var(--white);
          background: var(--primary-default);
          border: 1px solid transparent;
        `;
      } else if (secondary) {
        baseStyles += `
          color: var(--secondary-default);
          background: transparent;
          border: 1px solid transparent;
        `;
      } else if (tertiary) {
        baseStyles += `
          color: var(--content-subtitle);
          background: transparent;
          border: 1px solid transparent;
        `;
      } else {
        baseStyles += `
          background: var(--elevation-high);
          color: var(--secondary-default);
        `;
      }

      return baseStyles;
    }

    if (primary) {
      if (active) {
        return `
          color: var(--white);
          background: var(--primary-pressed);
          border: 1px solid transparent;
        `;
      }

      return `
        color: var(--white);
        background: var(--primary-default);
        border: 1px solid transparent;

        &:hover {
          background: var(--primary-hover);
        }
        
        &:active {
          background: var(--primary-pressed);
        }
      `;
    }

    if (secondary) {
      if (active) {
        return `
          color: var(--secondary-pressed);
          background: var(--wash-gray-default);
          border: 1px solid transparent;
        `;
      }

      return `
        color: var(--secondary-default);
        background: transparent;
        border: 1px solid transparent;

        &:hover {
          color: var(--secondary-hover);
          background: var(--wash-gray-default);
        }
        
        &:active {
          color: var(--secondary-pressed);
          background: var(--wash-gray-default);
        }
      `;
    }

    if (tertiary) {
      if (active) {
        return `
          color: var(--content-title);
          background: var(--wash-gray-default);
          border: 1px solid transparent;
        `;
      }

      return `
        color: var(--content-subtitle);
        background: transparent;
        border: 1px solid transparent;
        

        &:hover {
          color: var(--content-subtitle);
          background: var(--wash-gray-default);
        }
        
        &:active {
          color: var(--content-title);
          background: var(--wash-gray-default);
        }
      `;
    }

    if (active) {
      return `
        color: var(--secondary-pressed);
        background: var(--wash-gray-default);
      `;
    }

    return `
      background: var(--elevation-high);
      color: var(--secondary-default);

      &:hover {
        color: var(--secondary-hover);
        background: var(--wash-gray-hover);
      }

      &:active {
        color: var(--secondary-pressed);
        background: var(--wash-gray-pressed);
      }
    `;
  }}
`;

export { NewButton };
